import { styled } from '@creditas/stylitas'
import { TableHead } from '@creditas/table'

const CustomHead = styled(TableHead)`
  font-weight: 600;
`

export { CustomHead as TableHead }
